<template>
  <div :class="$style.container">
    <component
      :is="currentView"
      @update="updateReceipt"
      @submit="submitReceipt"
    />
  </div>
</template>

<script>
import HTTPService from '@/services/Http';
// import logrocket from '@/services/logrocket';

const COMPONENTS_MAP = {
  PANEL: () => import('organisms/receipt/components/ReceiptActionPanel'),
  INPUT: () => import('organisms/receipt/components/InputtingRecipientEmail'),
  LOADING: () => import('organisms/receipt/components/ProcessingSendReceipt'),
  SUCCESS: () => import('organisms/receipt/components/SuccessedSendReceipt'),
  FAIL: () => import('organisms/receipt/components/FailedSendReceipt'),
};

export default {
  name: 'ReceiptSender',
  props: {
    token: {
      type: String,
      required: true,
    },
    defaultStatus: {
      type: String,
      default: 'PANEL',
    },
  },
  data() {
    return {
      receipt: {
        email: '',
        status: this.defaultStatus,
      },
    };
  },
  computed: {
    currentView() {
      // PANEL | INPUT | LOADING | SUCCESS | FAIL
      return COMPONENTS_MAP[this.receipt.status];
    },
  },
  methods: {
    updateReceipt(data) {
      this.receipt = {
        ...this.receipt,
        ...data,
      };
    },
    async submitReceipt(data) {
      this.updateReceipt(data);

      try {
        await HTTPService.sendReceipt({
          token: this.token,
          email: this.receipt.email,
        });

        this.updateReceipt({ status: 'SUCCESS' });
      } catch (error) {
        // logrocket.logger(error);
        this.updateReceipt({ status: 'FAIL' });
      }
    },
  },
};
</script>

<style lang="sass" module>
  .container
    min-height: 54px
    position: relative

    +respond-to(medium)
      min-height: 64px
</style>
